// Shift Urgency Values
export enum UrgencyType {
  NCNS = 1,
  LATE_CANCELLATION = 2,
  LAST_MINUTE = 3,
}

export enum UrgentShiftLocalStorage {
  GENERAL_PRIMER_PAGE_VIEWED = "generalPrimerPageViewed",
  LAST_LOCATION_PERMISSION_STATUS = "lastLocationPermissionStatus",
  USER_DISABLED_FULL_LOCATION_PERMISSION = "userDisabledFullLocationPermission",
}

export enum LocationAccuracyStatus {
  FULL = "full",
  REDUCED = "reduced",
}

export const MIN_ANDROID_OS_WITH_ALWAYS_ALLOW_OPTION = "10.0.0";
